module.exports = __webpack_public_path__ + "static/media/grid2White.16cd0e3d.svg";